module.exports = __webpack_public_path__ + "img/201.problem_broken_toilet_seat.9c740a12.svg";